<!-- by 7527189 2 0 -->
<template>
  <a-row :gutter="24" >
    <a-col :md="24">
      <a-card  :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="单据号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="" v-model="topQueryParam.billCode"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="器械名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="" v-model="topQueryParam.billRemark"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="录入时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!-- <JDate  v-model:value="queryParam.createTime" /> -->
                  <a-range-picker style="width:100%" v-model="noQueryParam.createTime" format="YYYY-MM-DD"
                    :placeholder="['开始时间', '结束时间']" @change="onDateChange" @ok="onDateOk" />
                </a-form-item>
              </a-col>
              <a-button type="primary" @click="searchQuery">查询</a-button>
<!--              <a-button icon="setting" style="margin-left: 10px">列设置</a-button>-->
<!--              <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>-->
            </a-row>
          </a-form>
        </div>
        <div>
          <a-table ref="caijitable" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource"
            :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading"
            @change="handleTableChange">

            <span slot="action" slot-scope="text, record">
              <a @click="showDetail(record)">详情</a>
            </span>

            <span slot="regulatoryStatus" slot-scope="text, record">
              <a-tag v-if="record.regulatoryStatus == 1" color="green">已上传</a-tag>
              <a-tag v-if="record.regulatoryStatus == 2" color="orange">上传失败</a-tag>
              <a v-if="record.regulatoryStatus == 0" @click="uploadInfo(record,'追溯')">上传追溯</a>
              <a v-if="record.regulatoryStatus == 2" @click="uploadInfo(record,'追溯')">重新上传</a>
            </span>

            <span slot="retroactiveStatus" slot-scope="text, record">
              <a-tag v-if="record.retroactiveStatus == 1" color="green">已上传</a-tag>
              <a-tag v-if="record.retroactiveStatus == 2" color="orange">上传失败</a-tag>
               <a v-if="record.retroactiveStatus == 0" @click="uploadInfo(record,'监管')">上传监管</a>
              <a v-if="record.retroactiveStatus == 2" @click="uploadInfo(record,'监管')">重新上传</a>
            </span>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <detail-model  ref="detailModel" ></detail-model>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import ImportFileModal from '@/components/tools/ImportFileModal'
import { queryMaterialCategoryTreeList, gatheractivation, collectModify } from '@/api/api'
import { postAction,getAction, getFileAccessHttpUrl } from '@/api/manage'
import { getMpListShort } from '@/utils/util'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import JUpload from '@/components/jeecg/JUpload'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'
import { BillListMixin } from '../bill/mixins/BillListMixin'
import detailModel from './modules/detailModel'
export default {
  name: 'MaterialList',
  mixins: [JeecgListMixin,BillListMixin],
  components: {
    detailModel,
    JUpload,
    ImportFileModal,
    JEllipsis,
    JDate,
  },
  data () {
    return {
      List: [],
      // isUpload: false,
      //
      // headers: {
      //   'X-Access-Token': Vue.ls.get(ACCESS_TOKEN),
      //   tenantId: this.$store.getters.tenantId,
      //   createBy: this.$store.getters.userInfo.loginName,
      // },
      categoryTree: [],
      mPropertyListShort: '',
      model: {},
      labelCol: {
        span: 3,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // fileList: [],
      // 查询条件
      topQueryParam: {
        billRemark: '',
      },
      noQueryParam:{
        createTime: '',
      },
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '50', '100', '200'],

      },
      // 实际表头
      columns: [],
      // 初始化设置的表头
      settingColumns: [
        'billRemark',
        'action',
        'createBy',
        'recordTime',
        'billCode',
        'createTime',
        'regulatoryStatus',
        'retroactiveStatus'
      ],
      // 默认索引
      defDataIndex: [
        'batchNumber',
      ],
      // 默认的列
      defColumns: [
        { title: '单据号', dataIndex: 'billCode'},
        { title: '单据描述', dataIndex: 'billRemark'},
        { title: '操作人', dataIndex: 'createBy'},
        { title: '录入时间', dataIndex: 'recordTime'},
        { title: '上传时间', dataIndex: 'createTime'},
        { title: '追溯状态', dataIndex: 'regulatoryStatus',scopedSlots: { customRender: 'regulatoryStatus' }},
        { title: '监管状态', dataIndex: 'retroactiveStatus',scopedSlots: { customRender: 'retroactiveStatus' }},
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 80,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/trace/machine/info/list',
      },
    }
  },
  created () {
    this.initColumnsSetting()
    // this.loadTreeData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
    },
  },
  methods: {
    //打开详情
    showDetail(record){
      this.$refs.detailModel.show(record)
      this.$refs.detailModel.title = '明细'
    },

    onDateOk () { },
    // 刷新列表
    fatherMethod () {
      this.loadData(1)
    },
    onDateChange: function (value, dateString) {
      this.topQueryParam.beginTime = dateString[0]
      this.topQueryParam.endTime = dateString[1]
    },

    // 明细
    async details (record) {
      console.log(record, 'record')
      this.uploadfile({ uuid: record.uuid })
    },

    //加载初始化列
    initColumnsSetting () {
      let columnsStr = Vue.ls.get('caijitable')
      if (columnsStr && columnsStr.indexOf(',') > -1) {
        this.settingColumns = columnsStr.split(',')
      }
      this.columns = this.defColumns.filter((item) => {
        if (this.settingColumns.includes(item.dataIndex)) {
          return true
        }
        return false
      })
    },
    loadTreeData () {
      let that = this
      let params = {}
      params.id = ''
      queryMaterialCategoryTreeList(params).then((res) => {
        if (res) {
          that.categoryTree = []
          for (let i = 0; i < res.length; i++) {
            let temp = res[i]
            that.categoryTree.push(temp)
          }
        }
      })
    },
    batchSetMaterialCurrentStock () {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
      } else {
        let ids = ''
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        let that = this
        this.$confirm('是否操作选中数据?', '确认操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          that.loading = true
            postAction(that.url.batchSetMaterialCurrentStockUrl, { ids: ids })
              .then((res) => {
                if (res.code === 200) {
                  that.$message.info('修正库存成功！')
                  that.loadData()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.data.message)
                }
              })
              .finally(() => {
                that.loading = false
              })
        }).catch(() => {});
      }
    },
    batchEdit () {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
      } else {
        let ids = ''
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        this.$refs.batchSetInfoModalForm.edit(ids)
        this.$refs.batchSetInfoModalForm.title = '批量编辑'
      }
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.disableSubmit = false
      if (this.btnEnableList.indexOf(1) === -1) {
        this.$refs.modalForm.isReadOnly = true
      }
    },
    getImgUrl (imgName) {
      if (imgName && imgName.split(',')) {
        return getFileAccessHttpUrl('systemConfig/static/' + imgName.split(',')[0])
      } else {
        return ''
      }
    },
    handleImportXls () {
      let importExcelUrl = this.url.importExcelUrl
      let templateUrl = '/doc/goods_template.xls'
      let templateName = '商品Excel模板[下载]'
      this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
      this.$refs.modalImportForm.title = '商品导入'
    },
    searchReset () {
      this.queryParam = {
        mpList: getMpListShort(Vue.ls.get('materialPropertyList')), //扩展属性
      }
      this.loadData(1)
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
